import React from 'react'
import { reportDeliveryLabel } from '../lib/reportHistory'
export default function ReportDeliveryHistory({version,formatDate}) {
  if(!version.vat_snapshot_id)return null
  return <div className="fs11 text-muted" style={{marginTop:4}}>
    <div>PDF created {formatDate(version.artifact_created_at || version.created_at)}</div>
    {(version.delivery_history || []).map(delivery=><div key={delivery.id}>
      {reportDeliveryLabel(delivery.state)}{delivery.recipient ? ` to ${delivery.recipient}` : ''}
      {delivery.state==='sent' && delivery.sent_at ? ` · ${formatDate(delivery.sent_at)}` : ''}
    </div>)}
  </div>
}
